import { createContext } from 'react';

export const PreviewContext = createContext<PreviewContextProps>({
	isAuthenticated: false,
	onClickLogOut: () => {},
});

interface PreviewContextProps {
	isAuthenticated: boolean;
	onClickLogOut?: (url?: string) => void;
}
